import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import errors from './modules/errors'
import user from './modules/user'
import shop from './modules/shop'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: debug,
  modules: {
    app,
    errors,
    user,
    shop
  },
  actions: {
    initialState ({ commit }) {
      commit('user/setFacebookToken', JSON.parse(localStorage.getItem('userFacebookToken')))
      commit('app/setLoginSuccess', JSON.parse(localStorage.getItem('loginSuccess')))
    },
    onUserChange ({ commit, state }) {
      const loginSuccess = !state.app.inLoginProcess && state.app.loginSuccess
      if (loginSuccess) {
        commit('user/setStatus', true)
      }
    },
    loginProcess ({ commit }) {
      commit('app/setLoadingOverlay', true)
      commit('app/setInLoginProcess', true)
      commit('app/setLoginSuccess', false)
      commit('user/setFacebookToken', null)
    },
    loginSuccess ({ commit }) {
      commit('app/setLoadingOverlay', false)
      commit('app/setLoginSuccess', true)
      commit('app/setInLoginProcess', false)
      commit('user/setStatus', true)
      commit('errors/setLoginError', null)
      commit('errors/setNeedLoginError', null)
    },
    userLogout ({ commit }) {
      commit('app/setLoadingOverlay', false)
      commit('app/setInLoginProcess', false)
      commit('user/setStatus', false)
      commit('user/setFacebookToken', null)
    },
    createShopProcess ({ commit }) {
      commit('shop/setShowCreatShopDialog', true)
    }
  }
})
